export default __webpack_public_path__ + "static/media/demoprofile4.bfdfd100.svg";